// ./UserManagerContext.tsx
import { createContext, useContext, useState, ReactNode } from 'react';
// import { UserManager, WebStorageStateStore } from 'oidc-client';
import { UserManager } from 'oidc-client';

interface UserManagerContextType {
  userManager: UserManager | null;
  setUserManager: (manager: UserManager) => void;
}

const UserManagerContext = createContext<UserManagerContextType | undefined>(undefined);

export const useUserManager = () => {
  const context = useContext(UserManagerContext);
  if (!context) {
    throw new Error('useUserManager must be used within a UserManagerProvider');
  }
  return context;
};




// const oidcConfig = {
//   authority: 'http://localhost:9000/application/o/mercury-1/', // Base URL of your Authentik server
//   client_id: '1EGE8odaip0gM0nVPeF31PT6Dzvw4GFAG2hoZPBE', // Client ID from Authentik
//   redirect_uri: 'http://localhost:3000/auth/callback/local', // Your React app's callback URL
//   response_type: 'code',
//   scope: 'openid profile email entitlements',
//   post_logout_redirect_uri: 'http://localhost:3000/Not-Found', // Where to redirect after logout
//   userStore: new WebStorageStateStore({ store: window.localStorage }),
// };

export const UserManagerProvider = ({ children }: { children: ReactNode }) => {
  // const [userManager, setUserManager] = useState<UserManager| null>(new UserManager(oidcConfig));
  const [userManager, setUserManager] = useState<UserManager| null>(null);

  return (
    <UserManagerContext.Provider value={{ userManager, setUserManager }}>
      {children}
    </UserManagerContext.Provider>
  );
};
